import { mapActions } from "vuex";
import { computeAndSaveNewPostIndex } from 'surface/sorter'

const CLIP_HEIGHT = 144;

export default {
  data() {
    return {
      $_sectionSortMixin_initialized: false,
      $_sectionSortMixin_savePostHandler: null
    }
  },
  updated() {
    if (this.$_sectionSortMixin_initialized) {
      this.$_sectionSortMixin_makeSortable();
    } else {
      this.$_sectionSortMixin_destroySortable();
    }
  },
  beforeDestroy() {
    this.$_sectionSortMixin_destroySortable();
  },
  methods: {
    ...mapActions('post', ['sortedPost']),
    initializeSectionSort(savePostHandler) {
      this.$_sectionSortMixin_initialized = true
      this.$_sectionSortMixin_savePostHandler = savePostHandler
    },
    destroySectionSort() {
      this.$_sectionSortMixin_initialized = false
      this.$_sectionSortMixin_savePostHandler = null
    },
    $_sectionSortMixin_clipItems($el, e, item) {
      let clipBottom, clipTop;
      let itemHeight = item.height();
      let itemWidth = item.width();
      if (itemHeight > CLIP_HEIGHT) {
        let distanceFromTarget = e.offsetY;
        let distanceOfTargetFromTop = e.originalEvent.target.getBoundingClientRect().top - item[0].getBoundingClientRect().top;
        let distanceFromTop = distanceFromTarget + distanceOfTargetFromTop;
        if (distanceFromTop > CLIP_HEIGHT) {
          let distanceFromBottom = itemHeight - distanceFromTop;
          if (distanceFromBottom < CLIP_HEIGHT) {
            clipTop = itemHeight - CLIP_HEIGHT;
            clipBottom = itemHeight;
          } else {
            clipTop = distanceFromTop - CLIP_HEIGHT / 2;
            clipBottom = clipTop + CLIP_HEIGHT;
          }
          item.data("clipTop", clipTop);
        } else {
          clipTop = 0;
          clipBottom = CLIP_HEIGHT;
        }
        item.css("clip", "rect(" + clipTop + "px, " + itemWidth + "px, " + clipBottom + "px, 0)");
      }
      $el.addClass("ui-sortable-clipped");
    },

    $_sectionSortMixin_unclipItems($el, e, item) {
      let container = document.getElementById("wall-container");
      let oldOffsetTop = item[0].offsetTop;
      $el.removeClass("ui-sortable-clipped");
      let clipTop = item.data("clipTop") != null ? item.data("clipTop") : 0;
      let oldScrollTop = item.data("scrollTop") != null ? item.data("scrollTop") : 0;
      let newOffsetTop = item[0].offsetTop;
      let offsetDifference = newOffsetTop - oldOffsetTop;
      container.scrollTop = oldScrollTop + offsetDifference + clipTop;
      item.removeData("clipTop");
      item.removeData("scrollTop");
    },

    $_sectionSortMixin_saveScrollPosition($el, e, item) {
      let container = document.getElementById("wall-container");
      item.data("scrollTop", container.scrollTop);
    },

    $_sectionSortMixin_markItemAsTransiting(item) {
      item.addClass('noclick in-transit');
    },

    $_sectionSortMixin_unmarkItemAsTransiting(item) {
      item.removeClass('noclick in-transit');
    },

    $_sectionSortMixin_savePost(postCid, newSortIndex, newSectionId) {
      if (this.$_sectionSortMixin_savePostHandler) {
        this.$_sectionSortMixin_savePostHandler({
          postCid: postCid,
          sortIndex: newSortIndex,
          sectionId: newSectionId
        })
      }
    },
    $_sectionSortMixin_makeSortable() {
      let $el = $(this.$el).find('.section-posts');
      if (!$el.sortable("instance")) {
        $el.sortable({
          connectWith: ".surface-section .section-posts",
          cursor: 'move',
          items: '> .wish-editable:not(#wish-new)',
          scrollSensitivity: 48,
          cancel: '[contenteditable], .ui-resizable-handle, object, embed, input, button, textarea, select, option',
          start: (e, ui) =>{
              $el.addClass('ui-sortable-sorting');
              this.$_sectionSortMixin_clipItems($el, e, ui.item);
              $el.sortable("refreshPositions");
              this.$_sectionSortMixin_markItemAsTransiting(ui.item);
          },
          beforeStop: (e, ui) => {
            this.$_sectionSortMixin_saveScrollPosition($el, e, ui.item);
          },
          stop: (e, ui) => {
            $el.removeClass('ui-sortable-sorting');
            if (this.$_sectionSortMixin_format === "stream" || this.$_sectionSortMixin_format === "shelf") {
              this.$_sectionSortMixin_unclipItems($el, e, ui.item);
            }
            this.$_sectionSortMixin_unmarkItemAsTransiting(ui.item);
          },
          over: (e, ui) => {
            ui.item.data('newSectionId', this.currentSectionId);
          },
          change: (e, ui) => {
            ui.item.removeData("prevWishId nextWishId");
            let $placeholder = ui.placeholder;
            ui.item.data({
              prevWishId: $placeholder.prev(".wish").attr("id"),
              nextWishId: $placeholder.next('.wish').attr("id")
            });
          },
          remove: (e, ui) => {
            ui.placeholder.remove();
            $el.sortable('cancel');
          },
          update: (e, ui) => {
            var options;
            if (ui.item.data('newSectionId') === this.currentSectionId) {
              options = {};
              options.sectionId = this.currentSectionId;
              options.prevId = ui.item.data("prevWishId");
              options.nextId = ui.item.data("nextWishId");
              if (!options.prevId) {
                options.prevId = null;
              }
              if (!options.nextId) {
                options.nextId = null;
              }
              computeAndSaveNewPostIndex(ui.item, options)
              ui.item.removeData("newSectionId prevWishId nextWishId");
            }
          }
        })
      }
    },
    $_sectionSortMixin_destroySortable() {
      let $el = $(this.$el).off(".sort").sortable("instance")
      if (!!$el) {
        $el.destroy()
      }
    }
  }
};